// extracted by mini-css-extract-plugin
export default {"bannerLogo":"styles_bannerLogo__TEhv-"};